import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();
  const activeEvent = localStorage.getItem('arsh:activeevent');

  if (isAuthenticated) {
    if (user?.userType === 'admin') {
      return <Navigate to="/admin" />;
    }
    if (user?.userType === 'speaker') {
      if (activeEvent) {
        return <Navigate to={`/${activeEvent}/speaker-dashboard`} />;
      }
      return <Navigate to={PATH_DASHBOARD.root} />;
    }
    if (user?.userType === 'exhibitor') {
      return <Navigate to="/exhibitor-dashboard/home" />;
    }
    if (user?.userType === 'client') {
      return <Navigate to="/client/app" />;
    }
    if (activeEvent) {
      return <Navigate to={`/${activeEvent}/event`} />;
    }
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  return <>{children}</>;
}
